import React, { useState } from 'react'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Stack, Alert, IconButton } from '@mui/material'
import { HiOutlineClipboardCopy } from 'react-icons/hi'

// Displays a kiosk's plaintext secret exactly once, as returned by the backend.
// The secret is only ever held in this component's own state (passed in as a prop)
// and is never written to localStorage, a service, or the console.
const KioskCredentialDialog = ({ open, onClose, kioskCode, secret }) => {
    const [copied, setCopied] = useState(false)

    const handleCopy = async () => {
        try {
            await navigator.clipboard.writeText(secret || '')
            setCopied(true)
        } catch (error) {
            console.error('Clipboard copy failed:', error)
        }
    }

    const handleClose = () => {
        setCopied(false)
        onClose()
    }

    return (
        <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
            <DialogTitle>Kiosk Credential — {kioskCode}</DialogTitle>
            <DialogContent>
                <Stack spacing={2} style={{ marginTop: '8px' }}>
                    <Alert severity="warning">
                        This secret is shown only once and cannot be retrieved again. Copy it now and share it with
                        whoever is setting up the device.
                    </Alert>

                    <Stack direction="row" spacing={1} alignItems="center">
                        <TextField
                            label="Secret"
                            value={secret || ''}
                            fullWidth
                            variant="outlined"
                            InputProps={{ readOnly: true }}
                        />
                        <IconButton onClick={handleCopy} title="Copy to clipboard">
                            <HiOutlineClipboardCopy />
                        </IconButton>
                    </Stack>

                    {copied && <Alert severity="success">Copied to clipboard.</Alert>}
                </Stack>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} color="primary" variant="contained">
                    Done
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default KioskCredentialDialog
